export const environment = {
  production: true,
  version: '20251205',
  //baseUrl:"https://testimretailNewBackend.listrytech.com"
  baseUrl:"https://imretail-backend.listrytech.com"
};
